import React from 'react';
import { useSearchParams } from 'react-router-dom';

const STATUS_CONFIG = {
  success: {
    icon: '\u2705',
    title: 'Pago confirmado',
    message: 'Tu pago fue procesado correctamente. Ya pods cerrar esta pgina y volver a la app.',
    color: '#155724',
    bg: '#d4edda',
    border: '#c3e6cb',
  },
  failure: {
    icon: '\u274C',
    title: 'Pago rechazado',
    message: 'No se pudo procesar tu pago. Pods intentar nuevamente desde la app.',
    color: '#721c24',
    bg: '#f8d7da',
    border: '#f5c6cb',
  },
  pending: {
    icon: '\u23F3',
    title: 'Pago en proceso',
    message: 'Tu pago est siendo procesado. Te notificaremos cuando se confirme.',
    color: '#856404',
    bg: '#fff3cd',
    border: '#ffeeba',
  },
};

const PaymentResult = ({ type }) => {
  const [searchParams] = useSearchParams();
  const config = STATUS_CONFIG[type] || STATUS_CONFIG.pending;
  const paymentId = searchParams.get('payment_id');

  return (
    <div style={containerStyle}>
      <div style={{ ...cardStyle, backgroundColor: config.bg, borderColor: config.border }}>
        <div style={iconStyle}>{config.icon}</div>
        <h1 style={{ ...titleStyle, color: config.color }}>{config.title}</h1>
        <p style={messageStyle}>{config.message}</p>
        {paymentId && (
          <p style={idStyle}>ID de operacin: {paymentId}</p>
        )}
        <div style={logoContainerStyle}>
          <span style={logoTextStyle}>Pea Roja La Plata</span>
        </div>
      </div>
    </div>
  );
};

const containerStyle = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#f5f5f5',
  padding: '20px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

const cardStyle = {
  maxWidth: '460px',
  width: '100%',
  borderRadius: '12px',
  border: '1px solid',
  padding: '40px 32px',
  textAlign: 'center',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
};

const iconStyle = {
  fontSize: '3.5rem',
  marginBottom: '16px',
};

const titleStyle = {
  fontSize: '1.5rem',
  fontWeight: 700,
  margin: '0 0 12px 0',
};

const messageStyle = {
  fontSize: '1rem',
  color: '#444',
  lineHeight: 1.5,
  margin: '0 0 20px 0',
};

const idStyle = {
  fontSize: '0.82rem',
  color: '#888',
  margin: '0 0 24px 0',
};

const logoContainerStyle = {
  borderTop: '1px solid rgba(0,0,0,0.1)',
  paddingTop: '16px',
  marginTop: '8px',
};

const logoTextStyle = {
  color: '#C73B33',
  fontWeight: 700,
  fontSize: '0.9rem',
};

export default PaymentResult;
